import { FC, MouseEvent } from "react";

import Button from "@/components/Button";
import { EventResource } from "@/types/resources";
import { EventsStatusEnum } from "@/utils/enums";

interface Props {
  status: EventsStatusEnum;
  onEventCancel: () => Promise<void>;
  onDelete: () => Promise<void>;
  setShouldCreateEvents: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (
    e: MouseEvent<HTMLButtonElement>,
    shouldCreateEvents: boolean
  ) => Promise<void>;
  isSubmitting: boolean;
  shouldCreateEvents: boolean;
  authorEmail: string;
  eventStartsAt: {
    id: number;
    starts_at: string;
    deleted: boolean;
    availabilityChecked: boolean;
    name: string;
  }[];
  events: EventResource[];
}

const ProductionEventButtons: FC<Props> = ({
  status,
  onEventCancel,
  setShouldCreateEvents,
  onSubmit,
  isSubmitting,
  shouldCreateEvents,
  authorEmail,
  eventStartsAt,
  events,
  onDelete,
}) => {
  return (
    <>
      <Button color="danger" onClick={() => onDelete()}>
        Delete
      </Button>
      {status === EventsStatusEnum.SENT ? (
        <Button color="danger" onClick={onEventCancel}>
          Cancel Events
        </Button>
      ) : (
        <Button
          onClick={(e: MouseEvent<HTMLButtonElement>) => {
            setShouldCreateEvents(false);
            onSubmit(e, false);
          }}
          $type="secondary"
          disabled={isSubmitting}
          loading={isSubmitting && !shouldCreateEvents}
        >
          Save to drafts
        </Button>
      )}
      <Button
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          setShouldCreateEvents(true);
          onSubmit(e, true);
        }}
        disabled={
          isSubmitting ||
          !authorEmail.includes("@boredpanda.com") ||
          status === EventsStatusEnum.SENT ||
          eventStartsAt?.filter((event) => !event.deleted && event.starts_at)
            .length !== events?.filter((event) => !event.deletedAt).length
        }
        loading={isSubmitting && shouldCreateEvents}
      >
        Send invites
      </Button>
    </>
  );
};

export default ProductionEventButtons;
